export enum CARD_INFO_TYPE_ENUM{
    STANDARD = 'STANDARD',
    OTHER_HOST_ACCOMODATION = 'OTHER_HOST_ACCOMODATION',
    RECOMMENDED_BY_THE_HOST = 'RECOMMENDED_BY_THE_HOST'
}